import { createSlice } from "@reduxjs/toolkit";
import storage from "../../constants/storage";

const initialState = {
  groupBooking: false,
  checkInData: [],
  userInputs: [],
  passengersKeys: [],
  journeysInfo: [],
  groupSelectedJourneysCard: [],
  groupBoardingPass: false,
  isPrimaryContact: false
};

export const groupBookingSlice = createSlice({
  name: "groupBooking",
  initialState: initialState,
  reducers: {
    initiateGroupBooking: (state) => {
      state = initialState;
      storage.removeItem("persist:root");
    },
    reset: () => initialState,
    setcheckInData: (state, action) => {
      state.checkInData = action.payload.checkInData;
    },
    setUserInputs: (state, action) => {
      state.userInputs = action.payload.userInputs;
    },
    setGroupBooking: (state, action) => {
      state.groupBooking = action.payload.groupBooking;
    },
    setPrimaryContact: (state, action) => {
      state.isPrimaryContact = action.payload.isPrimaryContact;
    },
    setJourneysInfo: (state, action) => {
      state.journeysInfo = action.payload.journeysInfo;
    },
    setPassengersKeys: (state, action) => {
      state.passengersKeys = action.payload;
    },
    setGroupSelectedJourneysCard: (state, action) => {
      state.groupSelectedJourneysCard = action.payload.groupSelectedJourneysCard;
    },
    setGroupBoardingPass: (state, action) => {
      state.groupBoardingPass = action.payload.groupBoardingPass;
    }
  }
});

export const { initiateGroupBooking, reset, setcheckInData, setUserInputs, setGroupBooking, setPrimaryContact, setJourneysInfo, setPassengersKeys, setGroupSelectedJourneysCard, setGroupBoardingPass } = groupBookingSlice.actions;

export default groupBookingSlice.reducer;